import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import PropTypes from "prop-types";

const FileImport = ({
  accepts,
  handleFileChange,
  selectedFile,
  labelText,
  error,
  bodyText,
}) => {
  const handleUploadFile = () => {
    document.getElementById("import-file").click();
  };
  return (
    <div className="import__file" data-testid="file-import">
      <label htmlFor="import-file">
        <span>{labelText || "File to Import"}</span>
        <div>
          <input
            type="text"
            placeholder="Select File To Import"
            value={selectedFile ? selectedFile.name : ""}
            className={error !== "" && "input__error"}
            disabled
          />
          <Button
            onClick={() => {
              handleUploadFile();
            }}
            variant={buttonVariants.primary}
            dataTestId="import-file-button"
            content="Browse"
          />
        </div>
        <span className={`input__error__message ${error !== "" && "show"}`}>
          {error}
        </span>
        <input
          type="file"
          className="import__file__input"
          id="import-file"
          accept={accepts}
          onChange={handleFileChange}
          data-testid="import-file-input"
        />
      </label>
      <div className="import__file__body_text">{bodyText || ""}</div>
    </div>
  );
};

export default FileImport;

FileImport.defaultProps = {
  error: "",
};

FileImport.propTypes = {
  accepts: PropTypes.string,
  handleFileChange: PropTypes.func.isRequired,
  selectedFile: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelText: PropTypes.string,
  error: PropTypes.string,
  bodyText: PropTypes.string,
};
